import { render, staticRenderFns } from "./ShortAnswer.vue?vue&type=template&id=6ba914f6&scoped=true"
import script from "./ShortAnswer.vue?vue&type=script&lang=js"
export * from "./ShortAnswer.vue?vue&type=script&lang=js"
import style0 from "./ShortAnswer.vue?vue&type=style&index=0&id=6ba914f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba914f6",
  null
  
)

export default component.exports